<template>
  <div>
    <div class="row">
      <div class="col-xs-3 vcenter">
        <div class="circle text-center vcenter">
          <svg
            aria-hidden="true"
            data-prefix="fas"
            data-icon="bars"
            class="categoryIcon"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            color="#fff"
          >
            <path
              fill="currentColor"
              d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
            />
          </svg>
        </div>
      </div>
      <div class="col-xs-10 vcenter">
        <p class="title">Навыки</p>
      </div>
    </div>

    <SkillItem v-for="item in items" :key="item.category" :value="item" />
  </div>
</template>

<script>
import SkillItem from "./SkillItem";

export default {
  name: "Skill",
  props: {
    items: {}
  },
  components: {
    SkillItem
  }
};
</script>
